import { ArrowRight } from '@liveauctioneers/hammer-ui-core/icons';
import { BodyPrimary, H1 } from '@liveauctioneers/hammer-ui-core/text';
import { Button } from '@liveauctioneers/hammer-ui-core/button';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';

type HowToWinBannerBigContentProps = {
    href: string;
    onCTAClick: () => void;
};

export const HowToWinBannerBigContent = ({ href, onCTAClick }: HowToWinBannerBigContentProps) => {
    const { formatMessage } = useIntl();
    return (
        <div className="flex min-w-0 flex-col items-center gap-xs text-center smMin:flex-1 smMin:items-start smMin:gap-md smMin:text-left">
            <div>
                <H1 className="text-text-primary">{formatMessage({ id: 'howToWinBanner.headline' })}</H1>
                <BodyPrimary className="smMax:hui-text-body-secondary">
                    {formatMessage({ id: 'howToWinBanner.subheadline' })}
                </BodyPrimary>
            </div>
            <Button
                as="a"
                className="w-fit"
                href={href}
                iconRight={ArrowRight}
                onClick={onCTAClick}
                size="md"
                style="primary"
                variant="outlined"
            >
                {formatMessage({ id: 'howToWinBanner.cta' })}
            </Button>
        </div>
    );
};
